<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{'PurchasesHistory' | lang}}</div>
    </header>
    <div>
      <storicoacquisti />
    </div>
    <!-- <footer>
      <button @click="logout">{{ 'logout' | lang }}</button>
    </footer> -->
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import storicoacquisti from '@/components/StoricoAcquisti.vue'

export default {
  name: 'StoricoAcquistiPage',
  mixins: [ page ],
  components: { storicoacquisti },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  beforeDestroy () {},
  mounted () {},
  watch: {}
}
</script>

<style lang="scss">

</style>
